import React, { useState, useEffect } from 'react'
import Link from 'next/link'
import Image from 'next/image'

export default function InfographicSection({ infographics }) {
    const [relatedInfographics, setInfographics] = useState([])
    useEffect(() => {
        setInfographics(infographics)
    }, [infographics])
    return (
        relatedInfographics?.length > 0 && relatedInfographics != null && relatedInfographics != undefined && relatedInfographics[0]?.image &&
        <>
            <div className="shadow-md rounded my-4 px-4 py-4">
                <h3 className="uppercase text-lg text-[#1b5df3] font-semibold pb-2 border-b-2"><i className='fa fa-file fa-lg text-[#1b5df3]'></i> Related Infographics</h3>
                <div className='mt-2 pr-2 max-h-60 overflow-auto'>
                    <div className="flex flex-col items-center space-y-2">
                        {relatedInfographics.map((data, index) => {
                            return (
                                <>
                                    <div key={index} className="max-w-sm mx-auto bg-white rounded overflow-hidden shadow-lg">
                                        <Link href={data.slug}>
                                            <Image
                                                priority={false}
                                                className="w-full object-cover"
                                                src={data.image}
                                                alt={data.image_alt}
                                                width={2000}
                                                height={2000}
                                            />
                                        </Link>
                                    </div>
                                </>
                            )
                        })}
                    </div>
                </div>
            </div>
        </>
    )
}
